// FlowersPop product configuration — Managed Integration v1.
// Motor = genérico; produto = configuração (spec §30). Sem `if product === ...` no motor.
// GLB em assets/models/blush-tulip.glb: exportado do Flowers_Tulipa.blend só com o que está
// visível e selecionado, modificadores aplicados, Draco nível 6. 19 malhas, 4 materiais.

const PRODUCT_CONFIG = {
  // Loja flowerspop.com — produto "Tulip Balloon-Flower Bouquet DIY" (criado em DRAFT, 23/09/2026).
  // No tema, preço e disponibilidade vêm da variante real (window.FLOWERSPOP_SHOPIFY, snippet Liquid);
  // os preços abaixo só valem no protótipo local, fora da Shopify.
  shopifyProductId: 8032283983914,

  model: {
    // ?v= = versão do export: aumentar a cada novo GLB para o navegador/CDN não usar o antigo em cache.
    url: "/assets/models/blush-tulip.glb?v=2",
  },

  // Parte do configurador -> material no GLB (nomes verificados no export).
  // Center = os 4 cachos do grupo "Center" no Blender (Cylinder.012/.015/.021/.022), inteiros em
  // MAT_Stems.001; tulipas = MAT_Stems (haste) + MAT_Petals (flor); laço = MAT_Bow.
  materials: {
    petals: "MAT_Petals",
    center: "MAT_Stems.001",
    stems: "MAT_Stems",
    bow: "MAT_Bow",
  },

  unmappedMaterials: [],

  // Malhas do GLB sem material nomeado que pertencem a uma parte (nome da malha -> parte).
  // Vazio: o export atual só leva objetos visíveis, todos com material.
  meshParts: {},

  // Cores padrão = balões Fengche 260 (paleta glossy do index.html), HEX medidos nas fotos
  // 800 px do fornecedor; só editar este bloco.
  defaults: {
    petals: { colorId: "light-pink", hex: "#ffa7c6", finish: "glossy" },
    // Center = cachos do grupo Center (MAT_Stems.001); vinculado às hastes, começa com a mesma cor.
    center: { colorId: "matcha-green", hex: "#90a345", finish: "glossy" },
    stems: { colorId: "matcha-green", hex: "#90a345", finish: "glossy" },
    bow: { colorId: "light-pink", hex: "#ffa7c6", finish: "glossy" },
  },

  enabledParts: ["petals", "center", "stems", "bow"],

  // Partes vinculadas (seguidora: líder): a seguidora recebe a cor da líder sempre que a líder
  // muda, até o cliente escolher uma cor na aba da própria seguidora; o reset vincula de novo.
  linkedParts: { bow: "petals", center: "stems" },

  // Códigos do catálogo físico, indexados pelo valor da paleta (ex.: glossy-matcha-green).
  // Fengche 260 (保定风车气球): ITEM NO. oficial lido na etiqueta de cada pacote
  // (tabela 260长条气球, http://www.fengcheballoon.com/pd.jsp?id=19).
  // Metálicos (marca Shuaian) ainda sem código.
  colorCodes: {
    "glossy-white": "F260170",
    "glossy-transparent": "F260300",
    "glossy-pearl-white": "F260570",
    "glossy-sand-white": "F260173",
    "glossy-gray": "F260190",
    "glossy-black": "F260150",
    "glossy-macaron-pink": "F260710",
    "glossy-light-pink": "F260031",
    "glossy-flamingo-red": "F260015",
    "glossy-light-rose-red": "F260013",
    "glossy-berry-red": "F260019",
    "glossy-red": "F260010",
    "glossy-wine-red": "F260303",
    "glossy-orange": "F260050",
    "glossy-lemon-yellow": "F260071",
    "glossy-yellow": "F260070",
    "glossy-macaron-yellow": "F260721",
    "glossy-skin-color": "F260172",
    "glossy-light-brown": "F260153",
    "glossy-brown": "F260151",
    "glossy-macaron-green": "F260740",
    "glossy-fruit-green": "F260095",
    "glossy-light-green": "F260094",
    "glossy-matcha-green": "F260099",
    "glossy-avocado-green": "F260097",
    "glossy-dark-green": "F260091",
    "glossy-macaron-blue": "F260750",
    "glossy-light-blue": "F260113",
    "glossy-haze-blue": "F260117",
    "glossy-dark-blue": "F260111",
    "glossy-macaron-purple": "F260760",
    "glossy-taro-purple": "F260133",
    "glossy-purple": "F260134",
    "glossy-light-purple": "F260132",
  },

  // Linha do fabricante por cor: define o acabamento do látex no renderer.
  // standard = brilhante · retro = Morandi acetinado · macaron = pastel acetinado ·
  // pearl = perolado · crystal = translúcido/transparente. Metálicos usam "metallic".
  colorSeries: {
    "glossy-white": "standard",
    "glossy-transparent": "crystal",
    "glossy-pearl-white": "pearl",
    "glossy-sand-white": "retro",
    "glossy-gray": "standard",
    "glossy-black": "standard",
    "glossy-macaron-pink": "macaron",
    "glossy-light-pink": "standard",
    "glossy-flamingo-red": "standard",
    "glossy-light-rose-red": "standard",
    "glossy-berry-red": "standard",
    "glossy-red": "standard",
    "glossy-wine-red": "crystal",
    "glossy-orange": "standard",
    "glossy-lemon-yellow": "standard",
    "glossy-yellow": "standard",
    "glossy-macaron-yellow": "macaron",
    "glossy-skin-color": "standard",
    "glossy-light-brown": "retro",
    "glossy-brown": "retro",
    "glossy-macaron-green": "macaron",
    "glossy-fruit-green": "standard",
    "glossy-light-green": "standard",
    "glossy-matcha-green": "retro",
    "glossy-avocado-green": "retro",
    "glossy-dark-green": "standard",
    "glossy-macaron-blue": "macaron",
    "glossy-light-blue": "standard",
    "glossy-haze-blue": "retro",
    "glossy-dark-blue": "standard",
    "glossy-macaron-purple": "macaron",
    "glossy-taro-purple": "retro",
    "glossy-purple": "retro",
    "glossy-light-purple": "standard",
  },

  // Arranjos do seletor "Change style". O atual é o deste produto; os demais ficam "Coming soon"
  // até terem modelo 3D preparado (os GLB do fornecedor são scans de malha única, sem partes
  // recoloríveis). Para liberar um arranjo: `url` da página do produto dele na Shopify.
  styles: [
    { id: "blush-tulip", name: "Blush Tulip", image: "/assets/styles/blush-tulip.jpg", current: true },
    { id: "fuchsia-hibiscus", name: "Fuchsia Hibiscus", image: "/assets/styles/fuchsia-hibiscus.jpg" },
    { id: "white-callas", name: "White Callas", image: "/assets/styles/white-callas.jpg" },
    { id: "white-daisies", name: "White Daisies", image: "/assets/styles/white-daisies.jpg" },
  ],

  // Tamanhos = variantes reais Shopify (§13), opção "Size".
  sizes: {
    small: { label: "Small", variantId: 44895850201130, sku: "FP-TULIP-DIY-S", price: 21 },
    medium: { label: "Medium", variantId: 44895850233898, sku: "FP-TULIP-DIY-M", price: 26 },
    large: { label: "Large", variantId: 44895850266666, sku: "FP-TULIP-DIY-L", price: 33 },
  },

  // Realidade aumentada ("View in your space"): altura real do buquê por tamanho, em metros.
  // PENDENTE: valores estimados — confirmar as medidas reais com a FlowersPop.
  ar: {
    heights: { small: 0.4, medium: 0.5, large: 0.6 },
    // "Sem mesa": o buquê flutua nesta altura acima do piso (metros), para o cliente não ter que se
    // abaixar. Também é o modo do QR code (computador e PDF), que abre o AR direto.
    tableHeight: 0.85,
    // Gerador de AR hospedado (aws/ar-service, Lambda na conta AWS "conta2"): gera GLB/USDZ de cada
    // configuração a partir de s3://flowerspop-ar-804734887650/templates/<product>.glb.
    service: "https://6a3qzklgzgppnzqu2ookhdqffy0swokk.lambda-url.us-east-1.on.aws",
    product: "blush-tulip",
  },

  // Metallic (§17): produto auxiliar "FlowersPop Metallic Upgrade", US$ 3.50 por parte metálica;
  // vai ao carrinho com quantidade = nº de partes metálicas e o mesmo _config_id do buquê.
  metallicUpgrade: {
    productId: 8032284016682,
    variantId: 44895850299434,
    sku: "FP-METALLIC-UPGRADE",
    price: 3.5,
  },
};

if (typeof module !== "undefined") module.exports = { PRODUCT_CONFIG };
